import type { AnyObject, ScreenItem } from 'shared/src/types';
import { Screens } from './pages/Screens/Screens.page';
import { ScreenRenderer } from './pages/ScreenRenderer';

type CommonScreenParams<T> = Partial<{
  instanceId: string;
  next_token: string;
  screen_name: string;
}> &
  T;

export type ScreensPageParamList = {
  BrandHome: CommonScreenParams<AnyObject>;
};

const devOnlyScreens: ScreenItem[] = __DEV__
  ? [
      {
        name: 'ScreenRenderer',
        component: ScreenRenderer,
        path: '/screen-renderer/:type',
        options: {
          title: 'Screen Renderer',
        },
      },
    ]
  : [];

export const ScreensPageScreens: ScreenItem[] = [
  {
    name: 'Screens',
    component: Screens,
    path: '/screens',
    options: {
      title: '에이블리 스토어 - 에이블리',
    },
    convertParams: props => {
      const formattedExtras =
        typeof props.extras === 'string'
          ? JSON.parse(props.extras)
          : props.extras;

      return {
        instanceId: props.instanceId,
        ...formattedExtras,
      };
    },
  },
  ...devOnlyScreens,
];
